import {FinancialInventoryTable} from '../_models/financial-inventory.model';
import {
    ColumnFilter,
    DataTableColumnData,
    DataTableConfig,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    TableAction
} from "@cas-hub/acabim-common-client";

export class InventoryDataProvider extends DataTableLazyLoadDataSource<FinancialInventoryTable> {
    rowsPerPage = 5;
    stateKey = 'PropertyLeaseData';
    constructor(
        isFilterEnabled: boolean,
        columnFilters: ColumnFilter[],
        actions: TableAction[],
        refresher: DataTableLazyLoadRefresher<FinancialInventoryTable>,
        readonly observableErrorListener?: DataTableObservableErrorListener,
        readonly observableCompleteListener?: DataTableObservableCompletionListener,
        readonly actionListener?: (action: TableAction) => void,
        titleOverride?: string
    ) {
        super(refresher, observableErrorListener, observableCompleteListener);
        this.isFilterEnabled = isFilterEnabled;
        this.columnFilters = columnFilters;
        this.actions = actions;
        if (titleOverride) {
            this.config.tableHeading = titleOverride;
        }
    }

    isFilterEnabled: boolean;

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Code', objectPropertyName: 'code', colWidth: '12rem', textAlign: 'left'},
            {displayName: 'Name', objectPropertyName: 'name', textAlign: 'left'},
            {displayName: 'Cost', objectPropertyName: 'cost', colWidth: '10rem', textAlign: 'left'},
            {displayName: 'Price', objectPropertyName: 'price', colWidth: '10rem', textAlign: 'left'},
            {displayName: 'Account', objectPropertyName: 'account', colWidth: '10rem', textAlign: 'left'}
        ];

    readonly config: DataTableConfig = {
        tableHeading: 'Inventory',
        showTableHeading: true,
        isSearchEnabled: false,
        searchPlaceHolder: '',
        emptyMessage: 'No inventory items found',
        globalFilterFields: [],
        hasDetailsButton: true,
        hasCheckbox: false,
        isPaginationEnabled: true,
        isLazyLoadingEnabled: true,
        hasFilters: false,
        isExportEnabled: false,
        hasActions: false
    };

    readonly columnFilters: ColumnFilter[] = [];

    readonly actions: TableAction[] = [];

    onDataExpanded(value: FinancialInventoryTable): void {}

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

}
